import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { EndpointResponse } from '@/types/endpoints';
import { OrganizationSetting } from '@/types/organization';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'limit'>;

export async function getOrganizationSettings(
  scope: RequestScope,
  params: RequestParams = {},
  options: ReadRequestOptions
): Promise<EndpointResponse<OrganizationSetting[]>> {
  try {
    if (scope.kind !== 'organization') {
      throw new Error('Organization setting reads require an organization target scope');
    }
    const response = await scopedApi(scope).get<EndpointResponse<OrganizationSetting[]>>('organization/setting', {
      ...options,
      params: { limit: params.limit ?? 1000 },
    });
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
